import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../components/AppIcon";
import { useLanguage } from "../context/LanguageContext";

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    document.title = "Page Not Found | Acebarter";
  }, []);

  return (
    <div className="flex items-center justify-center py-24 px-4">
      <div className="text-center max-w-md">
        <div className="text-[120px] sm:text-[150px] font-black text-accent/10 leading-none font-data select-none">
          404
        </div>
        <h2 className="text-2xl font-bold text-foreground mb-2 -mt-4">
          Page Not Found
        </h2>
        <p className="text-sm text-muted-foreground mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={() => window.history?.back()}
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-card border border-border hover:border-accent/30 text-foreground text-sm font-semibold rounded-lg transition-colors"
          >
            <Icon name="ArrowLeft" size={16} />
            Go Back
          </button>
          <button
            onClick={() => navigate("/")}
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent hover:bg-accent-dark text-accent-foreground text-sm font-semibold rounded-lg transition-colors"
          >
            <Icon name="Home" size={16} />
            Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
